export const StringUtils = {
  size(string = '') {
    return new TextEncoder().encode(string).length;
  },
  replaceLineBreak(string = '', replacer = '') {
    return string.replace(/\r?\n|\r/gm, replacer);
  },
  toUpperCaseFirstChar(string = '') {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  getSlugFromUrl(url: string) {
    const path = url.replace(/^[\\/]?|[\\/]?$/gm, '').trim();

    return path.slice(path.lastIndexOf('/') + 1);
  },
  replaceExcepted(string: string) {
    return string.replace(/\u2028|\u2029/g, '');
  },
  removeTrailingSlash(string: string) {
    return string.replace(/\/$/, '');
  },
  getAttributesFromHtml(attribute: string, html = '') {
    const regex = new RegExp(`(?<=${attribute}=["'])[^"\\\\]+`, 'g');

    return html.match(regex);
  },
  replaceToNumbers(string: string) {
    return string.replace(/\D/g, '');
  },
};
